import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { ServiceCategoryFilter } from "../components/services/mockData";

const CATEGORY_KEYS: ServiceCategoryFilter[] = [
  "all",
  "guestServices",
  "activities",
  "externalServices",
  "guesteriaPartners",
];

export function useServiceCategoryPillOptions(
  values: ServiceCategoryFilter[] = CATEGORY_KEYS,
): { value: ServiceCategoryFilter; label: string }[] {
  const { t } = useTranslation();

  return useMemo(
    () =>
      values.map((value) => ({
        value,
        label: t(`analytics.categories.${value}`, value),
      })),
    [t, values],
  );
}
